import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import ReportIcon from "../assets/images/emerging_market_solutions_rgb_red.svg";
import "../assets/styles/reports.scss";

const reports = [
    {
        title: "Raport jakości geokodowania",
        description:
            "Raport pokazujący z jaką dokładnością została odnaleziona długość i szerokość geograficzna dla danego adresu.",
        href: "/reports/addresses-geocodequality",
    },
    {
        title: "Raport nowych adresów",
        description:
            "Raport pokazujący liczbę nowych rekordów adresowych dopisanych do bazy wzorcowej DHL.",
        href: "/reports/addresses-new",
    },
    {
        title: "Raport rekordów z niepełnymi polami",
        description:
            "Raport pokazujący rekordy dla jakich w warstwie informacyjnej widnieją nieuzupełnione pola.",
        href: "/reports/addresses-missing-fields",
    },
    {
        title: "Raport rekordów z pustymi polami",
        description:
            "Raport pokazujący rekordy dla jakich w warstwie informacyjnej widnieją jakiekolwiek puste pola w Warstwie Informacyjnej.",
        href: "/reports/addresses-all-missing-fields",
    },
    {
        title: "Raport normalizacji adresów",
        description: "",
        href: "/reports/cleaned_address",
    },
    {
        title: "Lista tras, z podziałem na terminal",
        description: "",
        href: "/reports/addresses-ex-pn",
    },
    {
        title: "Raport jakości uzupełnienia przedziałów godzinowych",
        description: "",
        href: "/reports/addresses-filling-hourly-intervals",
    },
];

const Reports = () => {
    return (
        <div className="reports-container">
            <Container fluid>
                <Row className="align-items-center mb-3">
                    <Col xs="auto">
                        <img
                            src={ReportIcon}
                            alt="Reports"
                            style={{ width: "30px", height: "30px" }}
                        />
                    </Col>
                    <Col>
                        <h3 style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                            Raporty
                        </h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="box-body">
                            <div className="list-group flat">
                                {reports.map((report) => (
                                    <Link
                                        key={report.href}
                                        to={report.href}
                                        className="list-group-item"
                                    >
                                        <h4 className="list-group-item-heading">{report.title}</h4>
                                        {report.description ? (
                                            <p className="list-group-item-text">
                                                {report.description}
                                            </p>
                                        ) : null}
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Reports;
